import React from 'react';
import DroneShowcase from './components/DroneShowcase';
import './App.css';

function App() {
  return (
    <div className="min-h-screen bg-slate-900 overflow-hidden">
      <DroneShowcase />
    </div>
  );
}

export default App;